import { inject, Service } from '@angular/core';
import { SessionService } from './session-service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Api } from './api';
import { NotificationService } from '../services/notification-service';

@Service()
export class Auth {
    private sessionService = inject(SessionService);
    private api = inject(Api);
    private notificationService = inject(NotificationService);
    
    private isAuthenticated = new BehaviorSubject<boolean>(false);
    constructor() {}

    login(phoneNumber: string, serialCode: string): Promise<boolean> {
    // Implement your actual login logic here
    return new Promise((resolve) => {
      const payload = {mobile_number:phoneNumber,serial_number:serialCode}
      console.log(payload)
      this.api.postData(payload,environment.checkUser).subscribe({
        next: (response: HttpResponse<any>) => {
        if (response.status === 200) {
          console.log('response body', response.body)
          this.sessionService.formSubData.set(response.body)
          // this.sessionService.saveData(response.body);        
          this.isAuthenticated.next(true);
          this.notificationService.notify('Login successful!', 'success');
          resolve(true);
        }else{
          this.notificationService.notify('Login failed!', 'warning');
          resolve(false);
        }
      },
      error: (err: HttpErrorResponse) => {
        // On network error, keep polling but log the error; optionally count as attempt
        console.log('error error', err.error)
        const errorMessage = (err.error && err.error.message) ? err.error.message : 'Something went wrong'
        // this.isAuthenticated.next(true);
        resolve(false);

        this.notificationService.notify(errorMessage, 'error');
      }
      })
    });
  }

  logout(): void {
    this.isAuthenticated.next(false);
    this.sessionService.clearSession();
  }

  isAuthenticated$(): Observable<boolean> {
    return this.isAuthenticated.asObservable();
  }
}
